import {
  transformDateToLocalDateString,
} from "helpers";
import { ReactSVG } from "react-svg";
import { FleetVehicleFireExtinguisherRow } from "services/api/fleet/vehicles/fireextinguishers/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";


export const FLEET_VEHICLE_FIRE_EXTINGUISHER_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => [
    {
      title: "",
      field: "image",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div>
            <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
              <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                {row.name?.toString().charAt(0).toUpperCase()}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.name",
      field: "name",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.serialnumber",
      field: "serialNumber",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.amount",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div>
            <div className="text-sm text-slate-900 truncate">{row.price} €</div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.expense.search.expirationdate",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div className="text-sm text-slate-900 truncate">
            {transformDateToLocalDateString(row.expirationDate)}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.weight",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div>
            <div className="text-sm text-slate-900 truncate">{row.weight} kg</div>
          </div>
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <span onClick={(e) => onDeleteClick(e, row.id)} className="block w-10 h-10 flex items-center justify-center cursor-pointer bg-red-50 hover:bg-red-100 rounded-full" >
            <ReactSVG
              src={"/media/icons/trash.svg"}
              className="w-4 h-4 stroke-[#bd0000]"
            />
          </span>

        );
      },
    },
  ];
